import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import '../style/_producttags.scss';

export const ProductNameTagManager = (props) => {
  
  // Props
  const {
    product,
  } = props;

  // State
  const [loading, setLoading] = useState(false);

  // Internationalization
  const { t } = useTranslation();

  // useEffect

  return (
    <div className='ProductNameTagManager'>
      <div className='tagManagerWrapper'>

      </div>
      {loading ?
        <div className='productNameEditing'>

        </div> :
        <div className='productNameFixed'>{'name with tags'}</div>
      }
    </div>
  );
};

export default ProductNameTagManager;

